import { TranslateService } from "@ngx-translate/core";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { QuestionAndAnswer } from "../model/qna.model";
import { QnAService } from "../service/qna.service";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { PopupType } from "src/app/shared/enums/popup-types";

@Component({
  selector: "app-qna-form",
  templateUrl: "./qna-form.component.html",
  standalone: false,
})
export class QnAFormComponent implements OnInit {
  @Input() questionId?: number;
  @Output() closeForm = new EventEmitter<null>();

  isLoading = false;

  form!: FormGroup;

  constructor(
    public translate: TranslateService,
    private fb: FormBuilder,
    private qnaService: QnAService,
  ) {}

  ngOnInit(): void {
    if (this.questionId) {
      const subscription = this.qnaService.getSignleQuestion(this.questionId).subscribe((response) => {
        subscription.unsubscribe();
        this.initForm(response);
      });
    }
    else {
      this.initForm();
    }
  }

  initForm(question: QuestionAndAnswer = {} as QuestionAndAnswer) {
    const { questionSR, questionEN, answerSR, answerEN } = question;

    this.form = this.fb.group({
      questionSR: [questionSR, Validators.required],
      questionEN: [questionEN, Validators.required],
      answerSR: [answerSR, Validators.required],
      answerEN: [answerEN, Validators.required],
    });
  }

  submitForm() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
    }

    if (this.questionId) {
      this.isLoading = true;
      const updateSubscription = this.qnaService.updateQuestion(this.questionId, this.form.getRawValue()).subscribe({
        next: () => {
          updateSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Success, this.translate.instant("qna.successfull_update"));
          this.closeForm.emit(null);
        },
        error: (error) => {
          updateSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Danger, error.error.errors[0]?.description || error.toString());
        },
      });
    }
    else {
      this.isLoading = true;
      const createSubscription = this.qnaService.createQuestion(this.form.getRawValue()).subscribe({
        next: () => {
          createSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Success, this.translate.instant("qna.successfull_create"));
          this.closeForm.emit(null);
        },
        error: (error) => {
          createSubscription.unsubscribe();
          this.isLoading = false;
          showMessage(PopupType.Danger, error.error.errors[0]?.description || error.toString());
        },
      });
    }
  }
}
